import { BASE_PATH_SERVER } from './config';
import axios from 'axios';

export const getBudgetsApi = async (token) => {
  const dst = `${BASE_PATH_SERVER}get-budget`;
  const params = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};

// GET /get-budget/:idBudget — legacy. Lee la vista budget_client que ya trae
// los campos del cliente (name, rut, phone, address, commune, email,
// contactName) flat junto al presupuesto. Es la shape que consumen los
// BudgetDowload V1/V2/V3.
export const getBudgetByIdApi = async (token, idBudget) => {
  const dst = `${BASE_PATH_SERVER}get-budget/${idBudget}`;
  const params = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};

// GET /order/document-data?idBudget=X — devuelve { order, items } con el
// cliente flat (client_name, client_rut) que consume PDF/Order/Dowload.
export const getOrderDocumentDataApi = async (token, idBudget) => {
  const dst = `${BASE_PATH_SERVER}order/document-data?idBudget=${idBudget}`;
  const params = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};

export const createBudgetApi = async (token, data) => {
  const dst = `${BASE_PATH_SERVER}budgets`;
  const params = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: token },
    body: JSON.stringify(data),
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const postBudgetImageApi = async (token, image, budgetId) => {
  const dst = `${BASE_PATH_SERVER}upload-budget-image/${budgetId}`;

  const formData = new FormData();
  formData.append('image', image.file, image.name);

  const params = {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};

export const getItemsApi = async (token, id) => {
  const dst = `${BASE_PATH_SERVER}get-items-budget/${id}`;
  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const getBudgetConfigApi = async (token) => {
  const dst = `${BASE_PATH_SERVER}presupuestos/config`;
  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const getOrderConfigApi = async (token) => {
  const dst = `${BASE_PATH_SERVER}presupuestos/ordenes/config`;
  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const getOrderStaticDatagApi = async (token) => {
  const dst = `${BASE_PATH_SERVER}presupuestos/ordenes/document-static-data`;
  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const getStaticMantencionData = async (token) => {
  const dst = `${BASE_PATH_SERVER}mantenciones/document-static-data`;
  try {
    const response = await axios.get(dst, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  } catch (err) {
    return {
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    };
  }
};
export const getStaticVoucherData = async (token) => {
  const dst = `${BASE_PATH_SERVER}comprobantes/document-static-data`;
  try {
    const response = await axios.get(dst, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  } catch (err) {
    return {
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    };
  }
};

export const getStaticBudgetData = async (token) => {
  const dst = `${BASE_PATH_SERVER}presupuestos/document-static-data`;
  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const getImagesApi = async (token, id) => {
  const dst = `${BASE_PATH_SERVER}get-images-budget/${id}`;
  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const getImageApi = async (imgName) => {
  const dst = `${BASE_PATH_SERVER}get-image-budget/${imgName}`;
  const params = {
    method: 'GET',
  };
  return fetch(dst, params)
    .then((response) => response.url)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
export const updateBudgetApi = async (token, data, idBudget) => {
  const dst = `${BASE_PATH_SERVER}budgets/${idBudget}`;
  const params = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: token },
    body: JSON.stringify(data),
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};

export const getBudgetStatements = async () => {
  const dst = `${BASE_PATH_SERVER}get-budget-statements`;
  return fetch(dst)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};

export const deactivateBudgetApi = async (token, idBudget) => {
  const dst = `${BASE_PATH_SERVER}budgets/${idBudget}/deactivate`;
  const params = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};

export const activateBudgetApi = async (token, idBudget) => {
  const dst = `${BASE_PATH_SERVER}budgets/${idBudget}/activate`;
  const params = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
